import Image from 'next/image'

interface Props {
  title: string
  description?: string
  lists: StrapiImageFile[]
}

function IndustriesAndUseCases({ title, description, lists }: Props) {
  return (
    <section>
      <div className="container | py-10 md:py-18">
        <div className="max-w-col-10 mb-9 md:mb-14">
          <h3
            className="font-heading text-3xl md:text-5xl font-semibold text-blue-web-90 | mb-7 md:mb-9"
            dangerouslySetInnerHTML={{ __html: title }}
          />

          <p className="font-body text-lg md:text-xl text-blue-web-90">
            {description}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {lists.map(item => {
            return (
              <div
                key={item.alternativeText}
                className="flex flex-col rounded-2xl overflow-hidden"
              >
                <Image
                  src={item.url}
                  alt={item.alternativeText ?? ''}
                  width={item.width}
                  height={item.height}
                  className="hover:scale-110 hover:transition-all hover:ease-out"
                />
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default IndustriesAndUseCases
